import { forwardRef } from "react";
import BootstrapBtn from "react-bootstrap/Button";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import CustomLoader from "../CustomLoader";
import IconSvg from "../IconSvg";

const Button = forwardRef(function Button(
  {
    trackingName = "",
    title,
    size,
    children,
    loading = false,
    disabled,
    fullWidth = false,
    hugContent = false,
    spaceBetween,
    square = false,
    className,
    leftIconName,
    rightIconName,
    onClick = () => {},
    userGroup,
    ...other
  },
  ref,
) {
  // eslint-disable-next-line no-unused-vars
  const { tReady, ...otherProps } = other;

  const trackEvent = useButtonEventTracking();

  function handleClick(event) {
    const buttonName = title || children || leftIconName;

    trackEvent(trackingName, buttonName, userGroup);
    onClick(event);
  }

  return (
    <BootstrapBtn
      {...otherProps}
      ref={ref}
      size={size}
      className={classNames(
        loading && "loading",
        disabled && "disabled",
        fullWidth && "w-100",
        hugContent && "hug-content",
        ((!children && !fullWidth) || square) && "square",
        className,
      )}
      disabled={disabled || loading}
      title={title || children}
      onClick={handleClick}
    >
      <div
        className={classNames(
          "btn-container",
          spaceBetween && "justify-content-between",
          !children && "icon-only",
        )}
      >
        {leftIconName && (
          <div className={classNames("icon-container", size)}>
            <IconSvg name={leftIconName} />
          </div>
        )}

        {children && loading ? (
          <span
            className="btn-loader-container"
            title={children}
          >
            <CustomLoader
              variant="SpinnerMiddleGray"
              className={classNames("btn-loader", size)}
            />
          </span>
        ) : (
          children && <span className="btn-children-container">{children}</span>
        )}

        {rightIconName && (
          <div className={classNames("icon-container", size)}>
            <IconSvg name={rightIconName} />
          </div>
        )}
      </div>
    </BootstrapBtn>
  );
});

Button.propTypes = {
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hugContent: PropTypes.bool,
  square: PropTypes.bool,
  onClick: PropTypes.func,
  trackingName: PropTypes.string,
};

export default Button;
